export default __webpack_public_path__ + "static/media/02_photo.d37c323a.jpg";